export default __webpack_public_path__ + "static/media/token-metrics-2.b18068c3.svg";